/** Tiny history-API router helpers (the app has only two pages). */

let listeners: (() => void)[] = [];

export function navigate(path: string): void {
  history.pushState(null, '', path);
  for (const l of listeners) l();
}

export function onNavigate(fn: () => void): () => void {
  listeners.push(fn);
  window.addEventListener('popstate', fn);
  return () => {
    listeners = listeners.filter((l) => l !== fn);
    window.removeEventListener('popstate', fn);
  };
}
